import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Fitrite365Template} from "../_models/Fitrite365Template";
import {OAuthService} from "angular-oauth2-oidc";
import {SharedService} from "./shared.service";
import {PlanTemplateSearchCriteria} from "../_models/PlanTemplateSearchCriteria";
import {PagedResponse} from "../_models";
import {PlanTemplate} from "../_models/PlanTemplate";

@Injectable({providedIn: 'root'})
export class TemplateService extends SharedService{
  constructor(httpClient: HttpClient, private oauthService: OAuthService) {
    super(httpClient);
    console.log('Access token in TemplateService:', this.oauthService.getAccessToken());
  }

  searchBespokeTemplates(customerId: number) : Observable<Fitrite365Template[]>  {
    return this.httpClient.get<Fitrite365Template[]>('/api/templates/searchbespoketemplates/' + customerId);
  }

  getBespokeTemplateById(id: string) {
    return this.httpClient.get<Fitrite365Template>('/api/templates/getbespoketemplate/' + id);
  }

  getPlanTemplatesByUser() {
    return this.httpClient.get<PlanTemplate[]>('/api/templates/getplantemplatesbyuser');
  }

  searchPlanTemplates(request: PlanTemplateSearchCriteria) {
    return this.httpClient.post<PagedResponse<PlanTemplate>>('/api/templates/search', request);
  }
  getPlanTemplateById(id: string) {
    return this.httpClient.get<PlanTemplate>('/api/templates/getemplate/' + id);
  }
}
